export default [
    {
        path: 'relatorio-atividade-coletiva',
        component: () => import(
            /* webpackChunkName: 'atencao-basica-relatorio-cuidado-gestacao-puerperio' */
            '@/views/atencao-basica/relatorio-atividade-coletiva/Index'
        ),
        redirect: 'relatorio-atividade-coletiva/index',
        children: [
            {
                name: 'relatorio-atividade-coletiva-index',
                path: 'index',
                component: () => import(
                    '@/views/atencao-basica/relatorio-atividade-coletiva/List'
                ),
            },
        ],
    }
]